import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-loading-dots-animation',
  templateUrl: './loading-dots-animation.component.html',
  styleUrls: ['./loading-dots-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingDotsAnimationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
